import {Component, OnInit, Injectable, Inject, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {ImportFileDialogComponent} from '../createfromopenapi/import-file-dialog/import-file-dialog.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {saveAs} from 'file-saver';
import {of as observableOf} from 'rxjs';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ngxCsv} from 'ngx-csv';

interface Object {
    name: string;
    item?: Object[];
    request?: any;
    response?: any;
}

@Injectable({
    providedIn: 'root'
})
export class TreeFunctionService {

    flatJsonArray(flattenedAray: Array<Object>, node: Object[]) {
        const array: Array<Object> = flattenedAray;
        node.forEach(element => {
            if (element.item) {
                array.push(element);
                this.flatJsonArray(array, element.item);
            }
        });
        return array;
    }

    findNodeMaxId(node: Object[]) {
        const flatArray = this.flatJsonArray([], node);
        const flatArrayWithoutChildren = [];
        flatArray.forEach(element => {
            flatArrayWithoutChildren.push(element.name);
        });
        return Math.max(...flatArrayWithoutChildren);
    }

    findPosition(name: string, data: Object[]) {
        for (let i = 0; i < data.length; i += 1) {
            if (name === data[i].name) {
                return i;
            }
        }
    }

    findFatherNode(name: string, data: Object[]) {
        for (let i = 0; i < data.length; i += 1) {
            const currentFather = data[i];
            if (!currentFather.item) {
                currentFather.item = [];
            }
            for (let z = 0; z < currentFather.item.length; z += 1) {
                if (name === currentFather.item[z]['name']) {
                    return [currentFather, z];
                }
            }
            for (let z = 0; z < currentFather.item.length; z += 1) {
                if (name !== currentFather.item[z]['name']) {
                    const result = this.findFatherNode(name, currentFather.item);
                    if (result !== false) {
                        return result;
                    }
                }
            }
        }
        return false;
    }

}


@Component({
    selector: 'app-collection',
    templateUrl: './collection.component.html',
    styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit {

    postmanCollection: any;
    items: Object[];
    code: string;

    treeControl = new NestedTreeControl<Object>(node => node.item);
    dataSource = new MatTreeNestedDataSource<Object>();
    tabData: any = [];
    activeTabIndex: any;
    collectionData: any = [];
    showDoc = false;
    paramsTobeSent: any;
    account = localStorage.getItem('account');
    partner = localStorage.getItem('partner');
    id = -1;
    folderName = 'New Folder';
    folderDescription = '';
    collectionList = [];
    isNewRequest = false;
    reqType = 'GET';
    reqName = 'New Request';
    reqDescription = '';
    viewStatus = true;
    statusText = '';
    status = '';
    shareEmail = '';
    loading1: boolean;


    constructor(public dialog: MatDialog, public platform: LeftpanelComponent, private confPost: ConfService, private service: TreeFunctionService) {
        this.tabData.push({method: 'GET', apiUrl: '', params: {}});
    }

    ngOnInit() {
        this.getCollection();

    }

    getCollection() {
        this.collectionData = [];
        this.loading1 = true;
        // this.collectionList = this.collectionData;
        // this.dataSource.data = this.collectionData;
        // const loaderDialog1 = this.dialog.open(LoaderWithProgressComponent, {
        //     maxWidth: '95vw',
        //     maxHeight: '60vh',
        // });
        const queryParams = 'account=' + this.account + '&partner=' + this.partner;
        this.confPost.getData('services', 'services', 'v1', 'collections', queryParams).subscribe(response => {
            const temp: any = response;
            if (response && temp.length > 0) {
                this.collectionList = temp;
                // console.log(this.collectionList);
                for (const item of temp) {
                    this.postmanCollection = Object.keys(item['collections']).map(e => item['collections'][e]);
                    this.postmanCollection.splice(0, 1);
                    this.items = this.postmanCollection[0];
                    const temp1 = {
                        'name': item['collections']['info']['name'],
                        'description': item['collections']['info']['description'],
                        'item': this.items,
                    };
                    this.collectionData.push(temp1);
                }
                this.dataSource.data = this.collectionData;
            } else {
                this.collectionData = [];
                this.dataSource.data = this.collectionData;
            }
            // loaderDialog1.close();
            this.loading1 = false;
        }, err => {
            // loaderDialog1.close();
            this.loading1 = false;
            this.platform.openSnackBar('Failed to read collection. Please try again', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    hasChild = (_: number, node: Object) => !!node.item && node.item.length > 0;

    addTab() {
        this.tabData.push({method: '', apiUrl: '', params: {}});
        this.activeTabIndex = this.tabData.length - 1;
    }

    addTab1(data) {
        let params = {};
        let url = '';
        let method = 'GET';
        let header = [];
        let bodyData = [];
        if (data['request'].hasOwnProperty('method')) {
            method = data.request.method;
        }
        if (data['request'].hasOwnProperty('header')) {
            header = data.request.header;
        }
        if (data['request'].hasOwnProperty('body')) {
            let bodyObj = {};
            if (data['request']['body'].hasOwnProperty('mode') && data['request']['body']['mode'] === 'raw' && data['request']['body']['raw'] !== '') {
                bodyObj = {
                    value: JSON.parse(data.request.body.raw),
                };
            } else {
                bodyObj = {
                    value: data.request.body.raw,
                };
            }
            bodyData.push(bodyObj);

        }
        if (data['request']['url'].hasOwnProperty('variable')) {
            params = data['request']['url']['variable'];
        }
        if (data['request']['url'].hasOwnProperty('raw')) {
            url = data.request.url.raw;
        } else {
            url = data.request.url;
        }

        let paramsObj = {
            'account': this.account,
            'partner': this.partner,
            'url': url,
            'params': params,
            'method': method,
            'header': header,
            'requestBody': bodyData,
            'type': 'collection'
        };
        this.paramsTobeSent = paramsObj;
        this.tabData.push({method: method, apiUrl: url, params: this.paramsTobeSent});
        this.activeTabIndex = this.tabData.length - 1;
    }

    closeTab(index) {
        this.tabData.splice(index, 1);
        this.activeTabIndex = this.tabData.length - 1;
    }

    tabNameChanged(tabName, index) {
        this.tabData[index].method = tabName.method;
        this.tabData[index].apiUrl = tabName.apiUrl;
    }

    buildCollection(code) {
        this.postmanCollection = Object.keys(code).map(e => code[e]);
        this.postmanCollection.splice(0, 1);
        this.items = this.postmanCollection[0];
        const treeData = this.dataSource.data;
        const temp = {
            'name': this.code['info']['name'],
            'description': this.code['info']['description'],
            'item': this.items,
        };
        treeData.push(temp);
        this.collectionData = code;
        this.InsertCollection();
    }

    addCollection() {
        this.isNewRequest = true;
        const dialogRef = this.dialog.open(ImportFileDialogComponent, {
            height: '60%',
            width: '40%'
        });
        dialogRef.afterClosed().subscribe(async file => {
            if (file) {
                const reader = new FileReader();
                // this.modeler.importXML(file, value => this.handleError(value));
                reader.addEventListener('load', (event: any) => {
                    try {
                        this.code = JSON.parse(event.target.result.toString());
                        this.buildCollection(this.code);

                    } catch (e) {
                        this.platform.openSnackBar('Please upload a valid file.', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                });
                reader.readAsText(file);
            }
        });
    }

    removeCollection(node) {
        this.id = -1;
        for (const item of this.collectionList) {
            if (item['collections']['info']['name'] === node['name']) {
                this.id = item['id'];
            }
        }
        if (window.confirm('Are you sure you want to delete ' + node.name + '?')) {
            const loaderDialog1 = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.confPost.deleteItemServices('v1', 'collections', this.id).subscribe(response => {
                this.platform.openSnackBar('Collection successfully removed.', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                loaderDialog1.close();
                this.getCollection();
            }, err => {
                loaderDialog1.close();
                this.platform.openSnackBar('Failed to remove collection. Please try again', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }
    }

    addRequest(node) {
        this.viewStatus = true;
        this.status = 'inprogress';
        let tempNode: Object;
        tempNode = {
            'name': this.reqName,
            'request': {
                'method': this.reqType,
                'header': [],
                'url': {},
                'description': this.reqDescription
            },
            'response': []
        };
        this.addChildNode({'currentNode': node, 'node': tempNode});
        this.getRoot(node);
    }

    addFolder(node) {
        this.viewStatus = true;
        this.status = 'inprogress';
        let tempNode: Object;
        tempNode = {
            'name': this.folderName,
            'item': []
        };
        this.addChildNode({'currentNode': node, 'node': tempNode});
        this.getRoot(node);
    }

    getAncestors(array, name) {
        if (typeof array !== 'undefined') {
            for (let i = 0; i < array.length; i++) {
                if (array[i].name === name) {
                    return [array[i]];
                }
                const a = this.getAncestors(array[i].item, name);
                if (a !== null) {
                    a.unshift(array[i]);
                    return a;
                }
            }
        }
        return null;
    }

    InsertCollection() {
        const payload = {
            account: this.account,
            partner: this.partner,
            collections: this.collectionData
        };
        const loaderDialog1 = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.addItemServices('v1', 'collections', payload).subscribe(response => {
            if (response) {
                this.platform.openSnackBar('Collection successfully added.', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                loaderDialog1.close();
            }
            loaderDialog1.close();
            this.getCollection();
        }, err => {
            loaderDialog1.close();
            this.platform.openSnackBar('Failed to add collection. Please try again', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    updateCollection(id, data) {
        this.status = 'inprogress';
        const payload = {
            'collections': data
        };
        this.confPost.patchItemServices('v1', 'collections', payload, id).subscribe(res => {
            if (res) {
                this.status = 'success';
            }
        }, err => {
            this.status = 'failure';
            this.platform.openSnackBar('Failed to update collection. Please try again', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });

    }

    shareCollection(node) {
    }

    exportCollection(node) {
        const ans = this.getAncestors(this.dataSource.data, node.name);
        for (const item of this.collectionList) {
            if (item['collections']['info']['name'] === ans[0]['name']) {
                const fileName = ans[0]['name'] + '.json';
                const blob = new Blob([JSON.stringify(item['collections'])], {type: 'application/json'});
                saveAs(blob, fileName);
                break;
            }
        }
    }

    refreshTreeData() {
        const data = this.dataSource.data;
        this.dataSource.data = null;
        this.dataSource.data = data;
        this.status = 'success';
        // console.log(this.dataSource.data);
    }

    addNode() {
        const node: Object = {
            'name': 'New Collection',
            'item': []
        };
        this.dataSource.data.push(node);
        this.refreshTreeData();
    }

    addChildNode(childrenNodeData) {
        childrenNodeData.currentNode.item.push(childrenNodeData.node);
        this.refreshTreeData();
    }

    editNode(nodeToBeEdited) {
        const fatherElement: Object = this.service.findFatherNode(
            nodeToBeEdited.currentNode.name,
            this.dataSource.data
        );
        let elementPosition: number;
        if (fatherElement[0]) {
            fatherElement[0].item[fatherElement[1]] = nodeToBeEdited.node;
        } else {
            elementPosition = this.service.findPosition(
                nodeToBeEdited.currentNode.name,
                this.dataSource.data
            );
            this.dataSource.data[elementPosition] = nodeToBeEdited.node;
        }
        this.refreshTreeData();
    }

    deleteNode(nodeToBeDeleted: Object) {
        this.viewStatus = true;
        this.status = 'inprogress';
        const deletedElement: Object = this.service.findFatherNode(
            nodeToBeDeleted.name,
            this.dataSource.data
        );
        let elementPosition: number;
        if (
            window.confirm(
                'Are you sure you want to delete ' + nodeToBeDeleted.name + '?'
            )
        ) {
            if (deletedElement[0]) {
                deletedElement[0].item.splice(deletedElement[1], 1);
            } else {
                elementPosition = this.service.findPosition(
                    nodeToBeDeleted.name,
                    this.dataSource.data
                );
                this.dataSource.data.splice(elementPosition, 1);
            }
            this.refreshTreeData();
        } else {
            this.status = 'cancel';
        }
    }

    renameNode(node) {
        this.viewStatus = true;
        this.status = 'inprogress';
        const text = (document.getElementById('renameText1') as HTMLInputElement).value;
        const tempNode = node;
        tempNode['name'] = text;
        this.editNode({'currentNode': node, 'node': tempNode});
        this.getRoot(node);
    }

    renameChildNode(node) {
        this.viewStatus = true;
        this.status = 'inprogress';
        const text = (document.getElementById('renameText') as HTMLInputElement).value;
        const tempNode = node;
        tempNode['name'] = text;
        this.editNode({'currentNode': node, 'node': tempNode});
        this.getRoot(node);
        this.refreshTreeData();
    }

    editChildNode(node) {
        this.viewStatus = true;
        this.status = 'inprogress';
        const text = (document.getElementById('editText') as HTMLInputElement).value;
        const reqTy = (document.getElementById('editReqType') as HTMLInputElement).value;
        const desi = (document.getElementById('editDes') as HTMLInputElement).value;
        const tempNode = node;
        tempNode['name'] = text;
        tempNode.request['description'] = desi;
        tempNode.request['method'] = reqTy;
        this.editNode({'currentNode': node, 'node': tempNode});
        this.getRoot(node);
        this.refreshTreeData();
    }

    isRoot(node) {
        const root = this.getAncestors(this.dataSource.data, node.name);
        if (root.length == 1) {
            return true;
        } else {
            return false;
        }
        return false;
    }

    getRoot(node) {
        const root = this.getAncestors(this.dataSource.data, node.name);
        const rootName = root[0]['name'];
        let itemToBeUpdated = [];
        let dataToBeUpdated = {};
        for (const item of this.dataSource.data) {
            if (item['name'] === rootName) {
                itemToBeUpdated = item['item'];
                break;
            }
        }
        // console.log('item', itemToBeUpdated);
        this.id = -1;
        for (const item of this.collectionList) {
            if (item['collections']['info']['name'] === rootName) {
                this.id = item['id'];
                // console.log('id', this.id);
                dataToBeUpdated = item['collections'];
                dataToBeUpdated['item'] = itemToBeUpdated;
                break;
            }
        }
        // console.log('data', dataToBeUpdated);

        if (this.id !== -1) {
            this.updateCollection(this.id, dataToBeUpdated);
        }
    }

    closeStatus() {
        this.viewStatus = false;
        this.status = '';
    }

    importCollectionUsingURL() {
        const dialogRef = this.dialog.open(ImportCollectionLinkComponent, {
            minWidth: '30vw'
        });

        dialogRef.afterClosed().subscribe(res => {
            if (res && res !== undefined && res !== null && res !== '') {
                this.code = res;
                this.buildCollection(this.code);
            }
        }, err => {
        });
    }

    runCollection(node) {
        let code = {};
        const ans = this.getAncestors(this.dataSource.data, node.name);
        for (const item of this.collectionList) {
            if (item['collections']['info']['name'] === ans[0]['name']) {
                code = item['collections'];
                break;
            }
        }
        const dialogRef = this.dialog.open(RunCollectionComponent, {
            width: '65vw',
            minHeight: '75vh',
            maxHeight: '95vh',
            data: code,
        });
    }
}

@Component({
    selector: 'import-collection-link-dialog',
    templateUrl: 'import-collection-link.html',
    styleUrls: ['import-collection-link.css'],
})
export class ImportCollectionLinkComponent implements OnInit {

    link = '';
    loading = false;
    viewSubmitBtn = true;
    code: any;

    jsonEditorOptions = new JsonEditorOptions();
    @ViewChild('editor') editor: JsonEditorComponent;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ImportCollectionLinkComponent>, public confPost: ConfService) {

        this.jsonEditorOptions.mode = 'code';
        this.jsonEditorOptions.modes = ['code', 'text', 'tree', 'view'];
        this.jsonEditorOptions.schema = '';
        this.jsonEditorOptions.statusBar = false;
        this.jsonEditorOptions.onChange = () => console.log( /*this.editor.get()*/);

    }

    ngOnInit(): void {
    }

    submitLink() {
        this.loading = true;
        this.confPost.getCollectionDataFromLink(this.link).subscribe(res => {
            this.code = res;
            this.loading = false;
            this.viewSubmitBtn = false;
        }, err => {
            this.loading = false;
            this.viewSubmitBtn = true;
            this.platform.openSnackBar('Error in fetching data from link. Please try again ', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    close() {
        this.dialogRef.close();
    }

    importCollection() {
        this.dialogRef.close(this.code);
    }
}

@Component({
    selector: 'run-collection-dialog',
    templateUrl: 'run-collection.html',
    styleUrls: ['run-collection.css'],
})
export class RunCollectionComponent implements OnInit {
    collectionName = '';
    deploymentPlan: any;
    apiExecutorPlans: any;
    authModel: any;
    variableList = [];
    variableListObj = [];
    viewConfiguration = false;
    viewRevertBtn = false;
    viewResult = false;
    totalNumberOfApis = 0;
    numOfApisExecuted = 0;
    numOfApisPassed = 0;
    numOfApisFailed = 0;
    applyAuthentication = false;
    applyPathParams = false;

    columns = ['Method', 'API Name', 'Version', 'Endpoint', 'Status Code', 'Status'];
    jobMappingToSort = ['method', 'name', 'version', 'endpoint', 'status_code', 'status'];
    parametersHeaders = ['key', 'value', 'description', 'req'];

    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<RunCollectionComponent>, public confPost: ConfService, private _service: ConnecttocrudService) {
        this.collectionName = this.data['info']['name'];
        this.buildDataList(this.data);
    }

    ngOnInit(): void {
    }

    buildDataList(obj) {
        // Object.keys(obj).forEach(key => {
        //     const keyslist = Object.keys(obj);
        //     if (typeof obj[key] === 'object' && obj[key] !== null) {
        //         if (!keyslist.includes('0') && (!keyslist.includes('item') || obj['item'].length === 0) && keyslist.includes('request') && key === 'request') {
        //             console.log(obj);
        //             let temp = {
        //                 'method': obj['request']['method'],
        //                 'name': obj['name'],
        //                 'version': 'v1',
        //                 'status_code': '',
        //                 'status': ''
        //             };
        //             if (obj['request']['url'].hasOwnProperty('raw')){
        //                 temp['endpoint'] = obj['request']['url']['raw'];
        //             } else {
        //                 temp['endpoint'] = obj['request']['url'];
        //             }
        //             if (temp['endpoint'] !== '') {
        //                 this.refinedExecutors.push(temp);
        //             }
        //         }
        //         this.buildDataList(obj[key]);
        //     }
        // });

        const loaderDialog1 = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.buildDeploymentPlanForPostmanCollection(this.partner, this.account, obj, '2.1', 'v1', 'THIRDPARTY', this.partner, true).subscribe(res => {
            this.deploymentPlan = res;
            this.viewRevertBtn = false;
            if (this.deploymentPlan && this.deploymentPlan !== undefined) {
                this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
                loaderDialog1.close();
                for (const item of this.apiExecutorPlans) {
                    item['status'] = '';
                    item['statusCode'] = '';
                    item['message'] = '';
                    if (item['apiExecutor']['apiUrl'].includes('{{')) {
                        const splitURL = item['apiExecutor']['apiUrl'].split('{{');
                        for (const item1 of splitURL) {
                            if (item1.length > 0 && item1.includes('}}')) {
                                if (!this.variableList.includes(item1.substring(0, item1.indexOf('}}')))) {
                                    const tempObj = {
                                        'key': item1.substring(0, item1.indexOf('}}')),
                                        'value': '',
                                        'description': ''
                                    };
                                    this.variableListObj.push(tempObj);
                                    this.variableList.push(item1.substring(0, item1.indexOf('}}')));
                                }
                            }
                        }
                    }
                    if (item['apiExecutor']['apiUrl'].includes('{')) {
                        const splitURL1 = item['apiExecutor']['apiUrl'].split('{');
                        for (const item2 of splitURL1) {
                            if (item2.length > 0 && item2.includes('}') && !item2.includes('}}')) {
                                if (!this.variableList.includes(item2.substring(0, item2.indexOf('}')))) {
                                    const tempObj1 = {
                                        'key': item2.substring(0, item2.indexOf('}')),
                                        'value': '',
                                        'description': ''
                                    };
                                    this.variableListObj.push(tempObj1);
                                    this.variableList.push(item2.substring(0, item2.indexOf('}')));
                                }
                            }
                        }
                    }
                }
            }
        }, err => {
            loaderDialog1.close();
            this.platform.openSnackBar('Failed to build executor plan for APIs. Please try again', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.dialogRef.close();

        });
    }

    getIconClass(type) {
        switch (type) {
            case 'API':
                return 'fa fa-table';
            case 'BUSINESSLOGIC':
                return 'fa fa-link';
            case 'SQLQUERY':
                return 'fa fa-database';
            case 'TESTSUITE':
                return 'fa fa-check-circle';
            case 'WORKFLOW':
                return 'fa fa-sitemap';
        }
    }

    getExecutorTypeName(type) {
        switch (type) {
            case 'API':
                return 'Data Access API';
            case 'BUSINESSLOGIC':
                return 'Business Logic API';
            case 'SQLQUERY':
                return 'SQL Query API';
            case 'TESTSUITE':
                return 'Testsuite API';
            case 'WORKFLOW':
                return 'Workflow API';
        }
    }

    getMethodClass(method) {
        switch (method) {
            case 'GET':
                return 'method-get';
            case 'PUT':
                return 'method-put';
            case 'POST':
                return 'method-post';
            case 'DELETE':
                return 'method-delete';
            case 'PATCH':
                return 'method-patch';
        }
    }

    close() {
        this.dialogRef.close();
    }

    changeData(value) {
        this.authModel = value;
        this.applyAuthentication = true;
    }

    changeParams(value) {
        this.applyPathParams = true;
    }

    getParamWidth(val) {
        return Math.floor(100 / (val.length - 1)).toString() + '%';
    }

    applyChanges() {
        if (this.applyPathParams) {
            for (const obj of this.variableListObj) {
                if (obj['value'] !== '' && obj['key'] !== '') {
                    for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                        const tempTxt = '{{' + obj['key'] + '}}';
                        const tempTxt1 = '{' + obj['key'] + '}';
                        if (this.apiExecutorPlans[i]['apiExecutor']['apiUrl'].includes(tempTxt)) {
                            this.apiExecutorPlans[i]['apiExecutor']['apiUrl'] = this.apiExecutorPlans[i]['apiExecutor']['apiUrl'].replace(tempTxt, obj['value']);
                        } else if (this.apiExecutorPlans[i]['apiExecutor']['apiUrl'].includes(tempTxt1)) {
                            this.apiExecutorPlans[i]['apiExecutor']['apiUrl'] = this.apiExecutorPlans[i]['apiExecutor']['apiUrl'].replace(tempTxt1, obj['value']);
                        }
                    }
                }
            }
        } else if (this.applyAuthentication && this.authModel !== undefined && this.authModel !== null) {
            for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                this.apiExecutorPlans[i]['apiExecutor']['authModel'] = this.authModel;
            }
        }
        // console.log(this.apiExecutorPlans);
        this.platform.openSnackBar('Configuration added successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
        this.applyAuthentication = false;
        this.applyAuthentication = false;
        this.viewConfiguration = false;
        this.viewRevertBtn = true;

    }

    changeviewConfiguration() {
        this.viewConfiguration = !this.viewConfiguration;
    }

    revertChanges() {
        this.buildDataList(this.data);
        this.viewRevertBtn = false;
    }

    executeAPIs() {
        this.viewConfiguration = false;
        this.viewResult = true;
        this.numOfApisExecuted = 0;
        this.numOfApisFailed = 0;
        this.numOfApisPassed = 0;
        this.totalNumberOfApis = this.apiExecutorPlans.length;
        for (let i = 0; i < this.apiExecutorPlans.length; i++) {
            const payload = this.apiExecutorPlans[i]['apiExecutor'];
            this._service.executeApi(payload).subscribe(res => {
                const temp = res;
                this.numOfApisPassed = this.numOfApisPassed + 1;
                this.apiExecutorPlans[i]['status'] = 'PASS';
                if (temp && temp.hasOwnProperty('statusCode')) {
                    this.apiExecutorPlans[i]['statusCode'] = temp['statusCode'];
                }
            }, err => {
                this.numOfApisFailed = this.numOfApisFailed + 1;
                this.apiExecutorPlans[i]['status'] = 'FAIL';
                this.apiExecutorPlans[i]['statusCode'] = err.error.statusCode;
                this.apiExecutorPlans[i]['message'] = err.error.body;
            });
        }
    }

    downloadReport() {
        let data = [];
        for (const item of this.apiExecutorPlans) {
            let obj = {
                method: item['apiExecutor']['executor_method_type'],
                name: item['apiExecutor']['executor_name'],
                version: item['apiExecutor']['executor_version'],
                url: item['apiExecutor']['apiUrl'],
                code: item['statusCode'],
                status: item['status'],
                error: item['message']
            };
            data.push(obj);
        }

        const fileName = this.collectionName + '_Report';
        const options = {
            headers: ['Method', 'API Name', 'Version', 'URL', 'Status Code', 'Status', 'Error']
        };
        new ngxCsv(data, fileName, options);
    }
}
